
// TODO: fix warnings
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/dot-notation */
export class CookieService {
    public set(name: string, value: string, options: object): void {
        options = {
            path: "/",
            ...options
        };

        if (options["expires"] instanceof Date) {
            options["expires"] = options["expires"].toUTCString();
        }

        let updatedCookie = encodeURIComponent(name) + "=" + encodeURIComponent(value);

        for (const optionKey in options) {
            updatedCookie += "; " + optionKey;
            const optionValue = options[optionKey];
            if (optionValue !== true) {
                // eslint-disable-next-line @typescript-eslint/restrict-plus-operands
                updatedCookie += "=" + optionValue;
            }
        }

        document.cookie = updatedCookie;
    }

    public get(name: string): string {
        const matches = document.cookie.match(new RegExp("(?:^|; )" + name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, "\\$1") + "=([^;]*)"));
        return matches ? decodeURIComponent(matches[1]) : null;
    }
}
